import { useEffect, useState } from 'react';
import { useReceiveMessage } from '../../../context/messageContext';
import { useAppointment } from '../../../context/appointmentContext';
import { ScreenMethodView } from '../../session/calibration/ClinicianCalibrationViews';
import { useCalibrationSync } from '../../session/calibration/sync';

// C3 Screen calibration method: Use Device Measurement / Use Card / Use Ruler.
//   device -> 'stepDeviceCalibration' (patient P3.1 Make/Device pickers), clinician waits (C3.1)
//   card   -> 'stepCardCalibration'   (unchanged)
//   ruler  -> 'stepRulerCalibration'  (unchanged)
const ScreenCalibration = ({ setStep, postMessage }) => {
  const [remoteUserRole, setRemoteUserRole] = useState(null);
  const [cardCalibrationDisabled, setCardCalibrationDisabled] = useState(false);
  const { appointment } = useAppointment();
  const messageFromRemoteUser = useReceiveMessage();
  const { patchCalibration } = useCalibrationSync();

  useEffect(() => {
    if (messageFromRemoteUser?.type === 'cardCalibrationDisabled') setCardCalibrationDisabled(true);
  }, [messageFromRemoteUser]);

  useEffect(() => {
    if (appointment?.currentUser?.role === 'patient') {
      setRemoteUserRole('optician');
    } else setRemoteUserRole('patient');
  }, [appointment?.currentUser?.role]);

  const select = (method) => {
    const type = { device: 'stepDeviceCalibration', card: 'stepCardCalibration', ruler: 'stepRulerCalibration' }[method];
    postMessage({ type });
    // A new device selection starts empty (the patient patches calibration.device when they submit).
    patchCalibration(method === 'device' ? { method, device: null } : { method });
    setStep(method);
  };

  const previousStep = () => {
    postMessage({ type: 'holding' });
    setStep('calibration-selection');
  };

  return (
    <ScreenMethodView
      onSelect={select}
      onBack={previousStep}
      cardDisabledReason={cardCalibrationDisabled ? `Card calibration is disabled as the ${remoteUserRole} is on a mobile device.` : null}
    />
  );
};

export default ScreenCalibration;
